var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _vm.$store.getters.tenantId === 1
        ? _c("subscribe-port-service-view")
        : _vm._e(),
      _vm.$store.getters.tenantId !== 1
        ? _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 10,
                      attrs: {
                        lazy: true,
                        label: _vm.$t("SystemMaintenance.MaritimeDataPush"),
                        name: "sea"
                      }
                    },
                    [_c("subscribe-port-push-rule-view")],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 11,
                      attrs: {
                        lazy: true,
                        label: _vm.$t("SystemMaintenance.AirFreightDataPush"),
                        name: "air"
                      }
                    },
                    [_c("subscribe-air-port-push-rule-view")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }